// extracted by mini-css-extract-plugin
export default {"card":"NewFolderCard_card__XKs8Y"};